import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { timestamp } from "rxjs/internal/operators/timestamp";
import { TaskSmall } from "./task-small";
import { CustomerProfile } from "./customer-profile";
import { CustomerProfileSmall } from "./customer-profile-small";
import { ContractCurrency } from "./contract-currency";

export class Contract {
    id: number;
    fullname: string;
    customerName: string;
    customerId: number;
    profileId: number;
    taskId: number;
    cvr: string;
    businessName: string;
    purchasePrice: string;
    soldPrice: string;
    travelPrice: string;
    overtimePrice: string;
    costPrice: string;
    currency: string;
    margin: string;
    startDate: Date;
    endDate: Date;
    weeklyHours: string;
    description: string;
    reg: string;
    account: string;
    accountType: string;
    iban: string;
    swift: string;
    paymentTerms: string;
    taskSmall: TaskSmall;
    createdDate: Date;
    taskTitle: string;
    startupPackage: string;
    equipment: string;
    option: string;
    customerProfiles: CustomerProfileSmall[]
    contractConsultantName: string;
    contractEmail: string;
    creditorName: string;
    consultingHouseContactPerson: string;
    communicationLanguage: string;


    contractCurrency?: ContractCurrency
}
